import { apiClient } from '../../apiHelper';
import { useFetch } from '../react-query';

export interface PredictionPerformanceRecord {
  id: string;
  study_instance_uid?: string;
  serie_instance_uid?: string;
  sop_instance_uid?: string;
  aas_bs_exam_id?: string;
  prediction_type: 'REALTIME' | 'BATCH' | 'BLIND_SWEEP';
  min_processing_time_ms: number;
  max_processing_time_ms: number;
  avg_processing_time_ms?: number;
  total_processing_time_ms?: number;
  frame_count?: number;
  session_id?: string;
  created_at: string;
}

export interface PredictionPerformanceResponse {
  records: PredictionPerformanceRecord[];
  pagination: {
    total: number;
    limit: number;
    offset: number;
    has_more: boolean;
  };
}

export function usePredictionPerformance(
  params: {
    prediction_type?: 'REALTIME' | 'BATCH' | 'BLIND_SWEEP';
    study_instance_uid?: string;
    session_id?: string;
    limit?: number;
    offset?: number;
    days?: number;
  } = {},
  config = {}
) {
  const fetchPerformance = async () => {
    // Remove undefined values from params to avoid sending "undefined" as string
    const cleanParams: Record<string, string | number> = {};
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        // Skip empty strings for string values, but allow 0 for numbers
        if (typeof value === 'string' && value === '') {
          return;
        }
        cleanParams[key] = value as string | number;
      }
    });
    const response = await apiClient.get('/prediction-performance', cleanParams);
    return response.data as PredictionPerformanceResponse;
  };

  return useFetch(fetchPerformance, ['prediction-performance', JSON.stringify(params)], config);
}

